import { successAction } from '../../../../../redux/constants';
import { SET_DRAFT_TABLEKEY } from '../constants';

export const setTableKey = (key, state) => {
  const thunk = async function thunk(dispatch) {
    dispatch(successAction(SET_DRAFT_TABLEKEY, { key, state }));
  };
  return thunk;
};
